module.exports = __webpack_public_path__ + "img/404.8d45efb7.png";